import interfacesImport from '../interface';

export default interfacesImport;
